var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m61.4 91.2-8.8-8.8 26.2-26.2H0V43.8h78.8L52.6 17.6l8.8-8.8 36.8 36.8c1.2 1.2 1.8 2.7 1.8 4.4s-.7 3.2-1.8 4.4L61.4 91.2z"}));
}

Arrow.defaultProps = {"viewBox":"0 0 100 100"};

module.exports = Arrow;

Arrow.default = Arrow;
